
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.735 11.37c-.047 0-.047-.047-.047-.047v-.43s0-.048.047-.095.096-.048.144-.048c.143 0 1.146-.096 1.384-.096l-.095-2.578s-.048-.287-.287-.334c-.286-.048-6.398-.86-6.685-.908-.047 0-.047-.047-.047-.047v-.382s0-.096.047-.144c0-.047.048-.047.144-.047h6.637c0-.526.048-2.245.477-2.674h.096c.43.43.43 2.148.43 2.674h6.685c.048 0 .095.047.143.047.048.048.048.144.048.144v.382c0 .047 0 .047-.048.047-.239.048-6.399.86-6.685.908-.239.047-.287.334-.287.334l-.095 2.578c.239 0 1.29.096 1.385.096.095 0 .143.048.143.048a.148.148 0 01.048.095v.43c0 .048-.048.048-.048.048l-1.72.095-1.814-.095z"}})])
          )
        }
      }
    